import { SRCard, SRCardProps } from '../sr-card/sr-card'
import { srCardContainerClasses, UserAreaContainer } from './styles'

type SRCardsContainerProps = {
  cards: SRCardProps[]
}

export const SRCardsContainer = ({ cards = [] }: SRCardsContainerProps) => {
  return (
    <UserAreaContainer>
      {cards.map((card, index) => {
        return (
          <SRCard
            {...card}
            key={index}
            containerClasses={srCardContainerClasses}
          />
        )
      })}
    </UserAreaContainer>
  )
}
